// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { getDatabase, ref, onValue } from 'firebase/database';
import { API_URL } from '../configs';
import useAuthStore from './auth';

let unsubscribe = null;

const useNotificationsStore = create((set) => ({
  notifications: {},

  reset: () => {
    if (unsubscribe) unsubscribe();
    unsubscribe = null;
    set({ notifications: {} });
  },

  attachNotificationsListener: () => {
    if (unsubscribe) return;
    const { user } = useAuthStore.getState();
    const { clientId } = user;
    if (!clientId) return;
    const node = ref(getDatabase(), `clientNotifications/${clientId}`);
    unsubscribe = onValue(node, (snapshot) => {
      set({ notifications: snapshot.val() || {} });
    });
  },

  deleteNotification: async (notificationId) => {
    try {
      await axios.delete(`${API_URL}/api/notifications/${notificationId}`);
    } catch (err) {
      console.error(err);
    }
  },
}));

export default useNotificationsStore;
